/**
 * Sample people for the first chat's previews: made-up names on free stock
 * headshots (Unsplash licence, face-cropped to 128px and bundled under
 * public/onboarding/people), each at a real company so its logo shows.
 * Nobody here is a real prospect.
 */

export interface SamplePerson {
  name: string;
  title: string;
  company: string;
  domain: string;
  photo: string;
}

const photo = (slug: string) => `/onboarding/people/${slug}.jpg`;

export const SAMPLE_PEOPLE: SamplePerson[] = [
  {
    name: 'Maya Chen',
    title: 'Head of RevOps',
    company: 'Plaid',
    domain: 'plaid.com',
    photo: photo('maya-chen'),
  },
  {
    name: 'Daniel Becker',
    title: 'VP Revenue Ops',
    company: 'Ramp',
    domain: 'ramp.com',
    photo: photo('daniel-becker'),
  },
  {
    name: 'Amara Okafor',
    title: 'RevOps Lead',
    company: 'Figma',
    domain: 'figma.com',
    photo: photo('amara-okafor'),
  },
  {
    name: 'Ravi Mehta',
    title: 'VP of Sales',
    company: 'Brex',
    domain: 'brex.com',
    photo: photo('ravi-mehta'),
  },
  {
    name: 'Claire Dubois',
    title: 'Dir. Revenue Ops',
    company: 'Intercom',
    domain: 'intercom.com',
    photo: photo('claire-dubois'),
  },
  {
    name: 'Samuel Adeyemi',
    title: 'VP Sales Development',
    company: 'Stripe',
    domain: 'stripe.com',
    photo: photo('samuel-adeyemi'),
  },
  {
    name: 'Emma Larsen',
    title: 'RevOps Manager',
    company: 'Gusto',
    domain: 'gusto.com',
    photo: photo('emma-larsen'),
  },
  {
    name: 'Marco Santos',
    title: 'Head of Sales Dev',
    company: 'Deel',
    domain: 'deel.com',
    photo: photo('marco-santos'),
  },
  {
    name: 'Sofia Russo',
    title: 'Dir. Sales Ops',
    company: 'Notion',
    domain: 'notion.so',
    photo: photo('sofia-russo'),
  },
  {
    name: 'Marcus Bell',
    title: 'VP Revenue',
    company: 'Vanta',
    domain: 'vanta.com',
    photo: photo('marcus-bell'),
  },
  {
    name: 'Luca Moretti',
    title: 'Head of GTM Ops',
    company: 'Linear',
    domain: 'linear.app',
    photo: photo('luca-moretti'),
  },
  {
    name: 'Andre Thomas',
    title: 'Sales Ops Lead',
    company: 'Airtable',
    domain: 'airtable.com',
    photo: photo('andre-thomas'),
  },
  {
    name: 'Isabel Ortiz',
    title: 'Head of Growth',
    company: 'Loom',
    domain: 'loom.com',
    photo: photo('isabel-ortiz'),
  },
  {
    name: 'Nicole Barnes',
    title: 'VP of Sales',
    company: 'Gong',
    domain: 'gong.io',
    photo: photo('nicole-barnes'),
  },
  {
    name: 'Ryan Walsh',
    title: 'Head of Sales',
    company: 'Datadog',
    domain: 'datadoghq.com',
    photo: photo('ryan-walsh'),
  },
  {
    name: 'David Mensah',
    title: 'Partnerships Lead',
    company: 'Vercel',
    domain: 'vercel.com',
    photo: photo('david-mensah'),
  },
  {
    name: 'Elena Petrova',
    title: 'Dir. Revenue Ops',
    company: 'Miro',
    domain: 'miro.com',
    photo: photo('elena-petrova'),
  },
  {
    name: 'Hannah Fischer',
    title: 'Marketing Ops Manager',
    company: 'Webflow',
    domain: 'webflow.com',
    photo: photo('hannah-fischer'),
  },
  {
    name: 'Omar Haddad',
    title: 'Sales Director',
    company: 'Retool',
    domain: 'retool.com',
    photo: photo('omar-haddad'),
  },
  {
    name: 'Camila Torres',
    title: 'BDR Manager',
    company: 'Calendly',
    domain: 'calendly.com',
    photo: photo('camila-torres'),
  },
  {
    name: 'Kwame Asante',
    title: 'Regional VP Sales',
    company: 'Mercury',
    domain: 'mercury.com',
    photo: photo('kwame-asante'),
  },
  {
    name: 'Karen Lindqvist',
    title: 'VP Operations',
    company: 'Klarna',
    domain: 'klarna.com',
    photo: photo('karen-lindqvist'),
  },
  {
    name: 'Laura Bianchi',
    title: 'Growth Lead',
    company: 'Canva',
    domain: 'canva.com',
    photo: photo('laura-bianchi'),
  },
  {
    name: 'Jake Novak',
    title: 'SDR Manager',
    company: 'Rippling',
    domain: 'rippling.com',
    photo: photo('jake-novak'),
  },
  {
    name: 'James Whitaker',
    title: 'Enterprise AE',
    company: 'Zapier',
    domain: 'zapier.com',
    photo: photo('james-whitaker'),
  },
];

/** The app's company logos (CompanyLogo reads the same CDN). */
export const logoUrl = (domain: string) =>
  `https://img.logo.dev/${domain}?token=pk_SQQ2koEUSE-cmBXPIycW-A`;
